/**
 * @description register builtin modules
 * @author wangfupeng
 */

// basic-modules
import '@webusi-net/basic-modules/dist/css/style.css'
import basicModules from '@webusi-net/basic-modules'

import '@webusi-net/list-module/dist/css/style.css'
import wangEditorListModule from '@webusi-net/list-module'

// table-module
import '@webusi-net/table-module/dist/css/style.css'
import wangEditorTableModule from '@webusi-net/table-module'

// video-module
import '@webusi-net/video-module/dist/css/style.css'
import wangEditorVideoModule from '@webusi-net/video-module'

// upload-image-module
import '@webusi-net/upload-image-module/dist/css/style.css'
import wangEditorUploadImageModule from '@webusi-net/upload-image-module'

// code-highlight
import '@webusi-net/code-highlight/dist/css/style.css'
import { wangEditorCodeHighlightModule } from '@webusi-net/code-highlight'

import registerModule from './register'

basicModules.forEach(module => registerModule(module))
registerModule(wangEditorListModule)
registerModule(wangEditorTableModule)
registerModule(wangEditorVideoModule)
registerModule(wangEditorUploadImageModule)
registerModule(wangEditorCodeHighlightModule)
